import { encoder } from "../services/encoder";
import { datalayers } from "../../../../../../../../modules/custom/co_150_trivia/source/modules/datalayers";

declare global {
  interface Window {
    dataLayer: any;
    CryptoJS: any;
    getUserTapit(): any;
  }
}
window.addEventListener("load", () => {
  dataLayers();
});

function dataLayers() {

  // ldatalayer al llenar campos del form

const form = document.getElementById(
  "webform-submission-registro-portal-add-form"
);

if (form) {
  form.addEventListener("change", (event) => {
    const field = event.target as HTMLInputElement | HTMLSelectElement;
    if (field && field.id === "edit-nombre" && field.name === "nombre") {
      const fieldName = field.name;
      const fieldValue = field.value;
      window.dataLayer.push({
        event: "GAEvent",
        event_name: "register_form_start",
        component_type: "Register Form",
        message_response: "Register Form Start",
        component_name: `register_form_field_${fieldName}`,
        field_value: fieldValue,
      });
    }
  });
}

// DL Email not found
if (document.getElementById('email-not-found')) {
  window.dataLayer.push({
    event: "GAEvent",
    event_name: "user_validation_failed",
    component_type: "User Validation Form",
    message_response: "Unregistered User",
    component_name: "user_validation_failed",
  });
}

  // DL Registro /bbc-wifi
  const btn_regiser_onboard = document.querySelectorAll(
    ".onboard__cont--link"
  ) as any;
  btn_regiser_onboard.forEach((element: any) => {
    element.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "GAEvent",
        event_name: "on_boarding_start",
        component_type: "On Boarding",
        component_name: "on_boarding_btn_start",
        message_response: "On Boarding Start",
        element_text: document.querySelector(".onboard__cont--link")
          ?.textContent,
      });
    });
  });

  // DL Link Ya estoy registrado
  const btn_registred_bbcwifi = document.querySelectorAll(
    ".onboard__cont--registred"
  ) as any;
  btn_registred_bbcwifi.forEach((element: any) => {
    element.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "GAEvent",
        event_name: "on_boarding_registered",
        component_type: "On Boarding",
        component_name: "on_boarding_btn_registered",
        message_response: "On Boarding Registered",
        element_text: document.querySelector(".onboard__cont--registred")
          ?.textContent,
      });
    });
  });

  // DL Btn BBC-WiFi Usuario ya registrado
  const btn__emailregistred = document.querySelector(".reconectnext") as any;
  /* const btn__emailregistred = document.querySelector(
    "[data-drupal-selector='edit-wizard-next']"
  ) as any; */
  if (btn__emailregistred) {
    btn__emailregistred.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "GAEvent",
        event_name: "user_validation_form_submit",
        component_type: "User Validation Form",
        component_name: "user_validation_btn_submit",
        message_response: "User Validation Form Submit",
        element_text: btn__emailregistred?.getAttribute("value"),
      });
    });
  }

  // DL Btn BBC-WiFi Usuario ya registrado
  const btn__registredquestion = document.querySelector(
    "[data-drupal-selector='edit-submit']"
  ) as any;
  const question1 = document.querySelector(
    ".js-form-item-pregunta-1 label"
  )?.textContent;
  if (btn__registredquestion) {
    btn__registredquestion.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "GAEvent",
        event_name: "data_enrichment_form_submit",
        component_type: "Data Enrichment Form'",
        component_name: "data_form_btn_submit",
        message_response: "Data Enrichment Form Submit",
        element_text: btn__registredquestion?.getAttribute("value"),
        question: question1,
        answer: "Answer selector",
      });
    });
  }

  // DL Btn BBC-WiFi Usuario no registrado
  const btn__unregistred = document.getElementById("unregisted") as any;
  btn__unregistred.addEventListener("click", (e: any) => {
    window.dataLayer.push({
      event: "GAEvent",
      event_name: "unregistered_action",
      component_type: "Unregistered",
      component_name: "unregistered_btn_start",
      message_response: "Sign Up Start",
      element_text: btn__unregistred?.textContent,
    });
  });

  // DL Thank You Page BBC-WiFi
  const btn__navigate = document.querySelector("#startTest") as any;
  let title = btn__navigate.getAttribute("value");
  btn__navigate.addEventListener("click", (e: any) => {
    window.dataLayer.push({
      event: "GAEvent",
      event_name: "wifi_conected_action",
      component_type: "Wifi Status Page",
      component_name: "wifi_connected_btn_ready",
      message_response: "Ok",
    });
  });

  // DL Expired Page
  const btn__reconect_expired = document.querySelector("#reconect") as any;
  btn__reconect_expired.addEventListener("click", (e: any) => {
    window.dataLayer.push({
      event: "GAEvent",
      event_name: "wifi_connection_expired",
      component_type: "Wifi Status Page",
      message_response: "Wifi Expired",
    });
  });

  /* ****************************************  */

  // Old DLs
  const btn_letter = document.querySelectorAll(
    ".btn_establishment_letter"
  ) as any;
  btn_letter.forEach((element: any) => {
    let title = element.getAttribute("data-title");
    element.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "BBC", // Categoría del evento (String). Requerido.
        eventAction: "Ver Carta", // Acción o subcategoría del evento (String). Requerido.
        eventLabel: title, // Etiqueta de descripción del evento (String). Requerido.
      });
    });
  });

  const btn_most_awarded = document.querySelectorAll(
    ".btn_most_awarded"
  ) as any;
  btn_most_awarded.forEach((element: any) => {
    let title = element.getAttribute("data-title");
    element.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "BBC", // Categoría del evento (String). Requerido.
        eventAction: "Ir a la tienda", // Acción o subcategoría del evento (String). Requerido.
        eventLabel: title, // Etiqueta de descripción del evento (String). Requerido.
      });
    });
  });

  const btn_experience = document.querySelectorAll(
    ".btn_plus_experience"
  ) as any;
  btn_experience.forEach((element: any) => {
    let title = element.getAttribute("data-title");
    element.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "BBC", // Categoría del evento (String). Requerido.
        eventAction: "Experiencias", // Acción o subcategoría del evento (String). Requerido.
        eventLabel: title, // Etiqueta de descripción del evento (String). Requerido.
      });
    });
  });

  window.CryptoJS = new encoder();
  document.addEventListener("tapitLoad", async (e: any) => {
    // Enviar datalayer
    const { user, isLogout, userNullTapit, newUser } = e.detail;
    const userAwaitTapit = await window.getUserTapit();
    window.dataLayer = window.dataLayer || [];
    if (newUser === true) {
      //Registro
      window.dataLayer.push({
        event: "Record",
        page: "bbccerveceria.com",
        medium: "Tapit",
        userID: window.CryptoJS.sha256(userAwaitTapit.user.email),
      });
    } else if (newUser === false) {
      //Login
      window.dataLayer.push({
        event: "login",
        medium: "Tapit",
        userID: window.CryptoJS.sha256(userAwaitTapit.user.email),
      });
    }
  });
}
